import * as React from 'react';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import Tap151Link from 'components/WelcomeParty/Tap151Link.tsx'
import Tap151MapLink from 'components/WelcomeParty/Tap151MapLink.tsx'
import Tap151ParkingMapLink from 'components/WelcomeParty/Tap151ParkingMapLink';

import tap151Sign from 'gallery/tap-151-sign.png';


export default function WelcomePartyDetails() {
  return (
    <Container sx={{
      display: 'flex',
      width: '100%',
      m: 0,
      p: 0,
    }}>
      <List sx={{ width: '100%' }}>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography variant="body2" component="span">Please come say "Hi" and join us at <Tap151Link underline='always' /> for 
                some bites and libations.
                <p>
                  Located in the heart of our home neighborhood "Cambridge Crossing", it is next to the Green Line T-Stop "Lechemere" and a short 15 minute walk from the Kimpton Marlowe. 
                </p>
                <p>Parking is available at the 222 Jacob Street Garage and will be validated by the restaurant.</p>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider component="li" />
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Location
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography component="span" sx={{fontSize: 16, fontWeight: "bold"}}><Tap151Link underline='always' /></Typography>
                <Typography variant="body2">
                  <Tap151MapLink />
                  <p>
                    If you have trouble finding the restaurant, follow the bike path north and west (away from the city) and it will be on the right. You will see signs as follows:
                    <br />
                    <img 
                      src={tap151Sign} 
                      style={{
                        display: 'flex',
                        width: "100%",
                      }}
                    />
                  </p>
                </Typography>

              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Parking
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2"><Tap151ParkingMapLink /></Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            slots={{secondary: 'div'}}
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Serving
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2" component="div">
                  <ul style={{paddingLeft: "1em", listStyleType:"none"}}>
                    <li>Savory and sweet bites such as:
                      <ul style={{paddingLeft: "2em"}}>
                        <li>sliders</li>
                        <li>flat-bread pizza</li>
                        <li>desserts</li>
                      </ul>
                    </li>
                    <li>Beer, Wine and Cocktails</li>
                  </ul>
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemText
            primary={
              <React.Fragment>
                <Typography 
                  variant="body1" 
                  component="span"
                  sx={{
                    fontWeight: "bold"
                  }}
                >
                  Dress Code
                </Typography>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                <Typography variant="body2" component="span">Smart-Casual (nice jeans, slacks, button down shirts, polos etc)</Typography>
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </Container>
  );
}
